import { render } from "./AppMenu.vue?vue&type=template&id=40b67db0&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=40b67db0&lang=scss&scoped=true"
import "./AppMenu.vue?vue&type=style&index=1&id=40b67db0&lang=scss"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b67db0"]])

export default __exports__